import { render } from "./GroupTable.vue?vue&type=template&id=397d021b&scoped=true&ts=true"
import script from "./GroupTable.vue?vue&type=script&lang=ts"
export * from "./GroupTable.vue?vue&type=script&lang=ts"

import "./GroupTable.vue?vue&type=style&index=0&id=397d021b&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d021b"]])

export default __exports__